import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { printerSelectors, printManager } from '@provider/print';
import { getComponentEntryQueryKey, ComponentFrameworkContextMenu } from '@utils/component-framework';
import { prepareIGuidePrint } from '../print.pdf/util.prepare-print.js';
import { convertIGuideToLatex } from '../print.word/_print.word.js';
import { useBacklinkUrl } from '../state/hook.backlink-url.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useShareIGuideEntryMutation } from '../state/mutation.share-entry.js';

function IGuideContextMenu(props) {
  const queryClient = useQueryClient();
  const backlinkUrl = useBacklinkUrl(props.component.entryKey);
  const shareEntryWithTeacherMutation = useShareIGuideEntryMutation();
  const onShareWithTeacher = () => {
    props.onShareWithTeacher?.();
    shareEntryWithTeacherMutation(props.component.entryKey);
  };
  const getPrintInput = useMemo(() => format => new Promise(resolve => {
    const entry = queryClient.getQueryData(getComponentEntryQueryKey(props.component.entryKey));
    if (format === "pdf") {
      prepareIGuidePrint(props.component, "export-service").finally(() => {
        resolve(document.querySelector(printerSelectors.container()) ?? document.body);
      });
    } else {
      resolve(convertIGuideToLatex(props.component, entry?.data, {
        backlink: backlinkUrl?.toString()
      }));
    }
  }), [backlinkUrl, props.component, queryClient]);
  const onPrint = async () => {
    await prepareIGuidePrint(props.component, "browser");
    printManager.triggerPrintDialog();
  };
  return /*#__PURE__*/jsxs(ComponentFrameworkContextMenu, {
    className: props.className,
    axis: "horisontal",
    nodeId: props.nodeId,
    layout: props.layout,
    enabled: props.enabled,
    children: [/*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "export",
      printOrientation: "portrait",
      componentTitle: props.component.envelope.Title,
      input: getPrintInput
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "drive",
      format: "docx",
      componentTitle: props.component.envelope.Title,
      entryKey: props.component.entryKey,
      input: getPrintInput,
      printOrientation: "portrait"
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "print",
      onClick: onPrint
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "share",
      componentId: props.component.envelope.ID,
      entryKey: props.component.entryKey,
      onShareWithTeacher: onShareWithTeacher
    }), props.children]
  });
}

export { IGuideContextMenu };
//# sourceMappingURL=integration.context-menu.js.map
